const MITT_NAF_URL =
  window.location.origin === "https://skademelding.naf.no"
    ? "https://www.nye.naf.no/mitt-naf"
    : "https://test.nye.naf.no/mitt-naf";
export default MITT_NAF_URL;
